import React, { useState } from 'react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { ColorsMap } from '@/utils/Theme'
import { Cookie, retrieve } from '@/utils/Helpers'

import { Button } from '@/components/Button'
import { InputText } from '@/components/InputText'
import { Text } from '@/components/Text'
import {
  StyledRegistration,
  Wrapper,
  InputWrapper,
  StyledForm,
  Flex,
} from './RegistrationStyles'

export const Registration: React.FC = () => {
  const { t } = useTranslation('common')

  const router = useRouter()

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  })

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value })
  }
  const handleSubmit = (event) => {
    event.preventDefault()
    let fail = false

    for (const [key, value] of Object.entries(state)) {
      if (value == '') {
        document.getElementById(key).style.borderColor = ColorsMap.error
        fail = true
      } else {
        document.getElementById(key).style.borderColor = ColorsMap.textDefault
      }
    }

    if (!fail) {
      if (
        state.password === state.confirmPassword &&
        state.password.length >= 8
      ) {
        const body = {
          first_name: state.firstName,
          last_name: state.lastName,
          email: state.email,
          password: state.password,
          repeat_password: state.confirmPassword,
        }
        retrieve('api/auth/register', 'POST', null, body)
          .then((res) => {
            if (res.status === 403) {
              throw new Error('403')
            } else if (res.status === 422) {
              throw new Error('422')
            }
            return res.json()
          })
          .then((res) => {
            Cookie.setText('token', res.data.token, 7)
            router.push('/')
          })
          .catch()
      } else {
        const password = document.getElementById('password')
        const confirmPassword = document.getElementById('confirmPassword')

        setState({ ...state, password: '', confirmPassword: '' })
        password.style.borderColor = ColorsMap.error
        confirmPassword.style.borderColor = ColorsMap.error

        alert('Password is to short or passwords do not match.')
      }
    }
  }

  return (
    <Wrapper>
      <StyledRegistration onSubmit={handleSubmit}>
        <Text textColor="primary" fontSize="xl" fontWeight="bold" m="2rem">
          {t('registration-title')}
        </Text>
        <StyledForm action="">
          <InputWrapper>
            <InputText
              width="100%"
              name="firstName"
              id="firstName"
              onChange={handleChange}
              value={state.firstName}
              label={
                <Flex>
                  <Text textColor="primary" fontWeight="bold">
                    {t('first-name')}
                  </Text>
                  <Text textColor="error" fontWeight="bold">
                    *
                  </Text>
                </Flex>
              }
            />
            <InputText
              width="100%"
              name="lastName"
              id="lastName"
              onChange={handleChange}
              value={state.lastName}
              label={
                <Flex>
                  <Text textColor="primary" fontWeight="bold">
                    {t('last-name')}
                  </Text>
                  <Text textColor="error" fontWeight="bold">
                    *
                  </Text>
                </Flex>
              }
            />
          </InputWrapper>
          <InputWrapper>
            <InputText
              width="100%"
              type="email"
              name="email"
              id="email"
              onChange={handleChange}
              value={state.email}
              label={
                <Flex>
                  <Text textColor="primary" fontWeight="bold">
                    {t('email-address')}
                  </Text>
                  <Text textColor="error" fontWeight="bold">
                    *
                  </Text>
                </Flex>
              }
            />
          </InputWrapper>
          <InputWrapper>
            <InputText
              width="100%"
              name="password"
              type="password"
              id="password"
              onChange={handleChange}
              value={state.password}
              label={
                <Flex>
                  <Text textColor="primary" fontWeight="bold">
                    {t('password')}
                  </Text>
                  <Text textColor="error" fontWeight="bold">
                    *
                  </Text>
                </Flex>
              }
            />
            <InputText
              width="100%"
              name="confirmPassword"
              type="password"
              id="confirmPassword"
              onChange={handleChange}
              value={state.confirmPassword}
              label={
                <Flex>
                  <Text textColor="primary" fontWeight="bold">
                    {t('confirm-password')}
                  </Text>
                  <Text textColor="error" fontWeight="bold">
                    *
                  </Text>
                </Flex>
              }
            />
          </InputWrapper>

          {/* <Text textColor="primary" fontSize="xl" fontWeight="bold" mt="3rem">
            {t('adress-title')}
          </Text>
          <InputWrapper>
            <InputText
              width="100%"
              name="city"
              onChange={handleChange}
              label={
                <Text textColor="primary" fontWeight="bold">
                  {t('city')}
                </Text>
              }
            />
            <InputText
              width="100%"
              name="address"
              onChange={handleChange}
              label={
                <Text textColor="primary" fontWeight="bold">
                  {t('street-address')}
                </Text>
              }
            />
          </InputWrapper>
          <InputWrapper>
            <InputText
              width="100%"
              name="zip"
              onChange={handleChange}
              label={
                <Text textColor="primary" fontWeight="bold">
                  {t('zip-code')}
                </Text>
              }
            />
            <InputText
              width="100%"
              name="delivery"
              placeHolder={t('company-name')}
              onChange={handleChange}
              label={
                <Text textColor="primary" fontWeight="bold">
                  {t('delivery-instructions')}
                </Text>
              }
            />
          </InputWrapper> */}

          <Button
            type="submit"
            variant="horizontalRad"
            colorVariant="primary"
            p="0 3rem"
            height="3.1rem"
            m="2rem auto"
            mb="4rem"
          >
            <Text fontWeight="bold">{t('register')}</Text>
          </Button>
        </StyledForm>
      </StyledRegistration>
    </Wrapper>
  )
}
